import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Fragment } from 'react';
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { BsChatDots } from "react-icons/bs";
import useFetchProductCategory from '../../../libs/getProductCategories';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import "./ProductCategory.css";
import { getCategoryPath } from "../libs/categoryRoutes";
import { getCategoryIcon, CATEGORY_LINK_SKELETON_COUNT } from "../libs/categoryIcons";
const CateMenu = () => {
    const [helpCenterVisible, setHelpCenterVisible] = useState(false);
    const { data, isLoading: productCategoryLoading, isError: productCategoryError } = useFetchProductCategory();


  const handleHelpCenterToggle = () => {
    setHelpCenterVisible(!helpCenterVisible);
  };

    return (
        <Fragment> 
        <div className='category-menu'>
        <div className="help-center-switch" onClick={handleHelpCenterToggle}>
           <span>
           <h3>NEED  HELP?</h3>
            {helpCenterVisible ? <IoIosArrowUp /> : <IoIosArrowDown />}
           </span>
          
          {helpCenterVisible && <div className="help-center-card">
            <Link to="/market/return-policy">FAQS</Link>
            {/* <Link>Payment Option</Link> */}
            <Link to="/market/track-order">Track an Order</Link>
            <Link to="/market/return-policy">Return & Refund</Link>
            <a href="/Contact">Contact Us</a>
            <div className="help-center-line">
            <a href="/" target='blank'><BsChatDots  style={{fontSize:'22px'}}/>Chat with Support Team</a>
            </div>
          </div> }
          </div>
             <div className="wrapper">
                <span>
                    <h3>PRODUCTS CATEGORIES</h3>
                    <Link to='/recommendedProduct'>See All</Link>
                </span>
                {productCategoryLoading ? (
            <div className="mobile-category market-category-skeleton">
              {Array.from({ length: CATEGORY_LINK_SKELETON_COUNT }).map((_, index) => (
                <div className="market-category-skeleton__row" key={index}>
                  <Skeleton circle width={20} height={20} />
                  <Skeleton height={14} borderRadius={6} containerClassName="market-category-skeleton__line" />
                </div>
              ))}
            </div>
          ) : productCategoryError ? ( 
            <p style={{fontFamily:'Montserrat'}}>Error loading categories</p>
          ) : data?.categories?.length > 0 ? (  
            data.categories.map((category) => (
              <div className="mobile-category" key={category._id}>
                <Link to={getCategoryPath(category.categoryName)}>
                {getCategoryIcon(category.categoryName)}
                {category.categoryName}
              </Link>
              </div>
            ))          ) : (
            <p style={{fontFamily: 'Montserrat'}}>No categories available</p>
          )}
             </div>
             <Link to="/market/sell">Become a merchant</Link>
        </div>
        </Fragment>
    );
}

export default CateMenu;
